export default "__VITE_ASSET__3e31226c__"